function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);} /* eslint-disable max-statements */
/* eslint-disable max-lines */
import React, { useEffect, useMemo, useState } from 'react';
import { Link, useBlocker, useLoaderData, useNavigate } from 'react-router-dom';

import { useForm } from 'react-hook-form';
import { useSetAtom } from 'jotai';

import { Translate } from "../../../../I18N";
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";
import { Button, Table } from "../../../Components/UI";
import { ConfirmNavigationModal, InputField } from "../../../Components/Forms";

import { notificationAtom } from "../../../atoms/notificationAtom";
import ThesauriAPI from "../../../api/thesauri";
import uniqueID from "../../../../../shared/uniqueID";

import {
  ThesauriValueFormSidepanel } from "./components/ThesauriValueFormSidepanel";


import { ThesauriGroupFormSidepanel } from "./components/ThesauriGroupFormSidepanel";
import { sanitizeThesaurusValues } from "./helpers";
import { ImportButton } from "./components/ImportButton";
import { columns } from "./components/TableComponents";

const editTheasaurusLoader =
(headers) =>
async ({ params: { _id } }) => {
  const response = await ThesauriAPI.getThesauri({ _id }, headers);
  return response[0];
};

const ThesaurusForm = () => {
  const navigate = useNavigate();
  const thesaurus = useLoaderData();
  const [showNavigationModal, setShowNavigationModal] = useState(false);
  const [groupFormValues, setGroupFormValues] = useState();
  const [itemFormValues, setItemFormValues] = useState([]);
  const [showThesauriValueFormSidepanel, setShowThesauriValueFormSidepanel] = useState(false);
  const [showThesauriGroupFormSidepanel, setShowThesauriGroupFormSidepanel] = useState(false);
  const [selectedThesaurusValue, setSelectedThesaurusValue] = useState(
    []
  );
  const [thesaurusValues, setThesaurusValues] = useState([]);
  const setNotifications = useSetAtom(notificationAtom);

  useEffect(() => {
    if (thesaurus) {
      const values = thesaurus.values || [];
      const valuesWithIds = values.map((value) => {var _value$values;return _objectSpread(_objectSpread({},
        value), {}, {
          _id: `temp_${uniqueID()}`,
          values: (_value$values = value.values) === null || _value$values === void 0 ? void 0 : _value$values.map((val) => _objectSpread(_objectSpread({},
          val), {}, {
            _id: `temp_${uniqueID()}` })
          ) });}
      );
      setThesaurusValues(valuesWithIds);
    }
  }, [thesaurus]);

  const {
    watch,
    register,
    getValues,
    handleSubmit,
    formState: { errors, isDirty }
  } = useForm({
    defaultValues: thesaurus,
    mode: 'onSubmit'
  });

  const blocker = useBlocker(({ nextLocation }) => {
    const nameHasChanged = isDirty;
    const hasSaved = nextLocation.pathname.includes('edit');
    if (hasSaved) return false;
    if (thesaurus) {
      // We are editing
      const valuesHaveChanged = thesaurusValues.length !== thesaurus.values.length;
      return valuesHaveChanged || thesaurus.name !== getValues().name;
    }
    const newValues = Boolean(thesaurusValues.length);
    return newValues || nameHasChanged;
  });

  useMemo(() => {
    if (blocker.state === 'blocked') {
      setShowNavigationModal(true);
    }
  }, [blocker, setShowNavigationModal]);

  const addItem = () => {
    setItemFormValues([]);
    setShowThesauriValueFormSidepanel(true);
  };

  const addGroup = () => {
    setGroupFormValues({
      _id: `temp_${uniqueID()}`,
      label: '',
      values: [{ label: '', _id: `temp_${uniqueID()}` }]
    });
    setShowThesauriGroupFormSidepanel(true);
  };

  const editGroup = (row) => {
    setGroupFormValues(row.original);
    setShowThesauriGroupFormSidepanel(true);
  };

  const editValue = (row) => {var _row$getParentRow;
    setItemFormValues([_objectSpread(_objectSpread({}, row.original), {}, { groupId: (_row$getParentRow = row.getParentRow()) === null || _row$getParentRow === void 0 ? void 0 : _row$getParentRow.original._id })]);
    setShowThesauriValueFormSidepanel(true);
  };

  const edit = (row) => {
    if (row.original.values) {
      editGroup(row);
    } else {
      editValue(row);
    }
  };

  const deleteSelected = () => {
    const parentsDeleted = thesaurusValues.filter(
      (currentValue) =>
      !selectedThesaurusValue.find((selected) => selected.original._id === currentValue._id)
    );

    const childrenDeleted = parentsDeleted.map((singleThesaurus) => {
      if (singleThesaurus.values) {var _singleThesaurus$valu;
        const newValues = (_singleThesaurus$valu = singleThesaurus.values) === null || _singleThesaurus$valu === void 0 ? void 0 : _singleThesaurus$valu.filter(
          (currentGroupItem) =>
          !selectedThesaurusValue.find((selected) => selected.original._id === currentGroupItem._id)
        );
        singleThesaurus.values = newValues;
      }
      return singleThesaurus;
    });

    setThesaurusValues(childrenDeleted);
  };

  const sortValues = () => {
    const valuesCopy = [...thesaurusValues];
    valuesCopy.sort((first, second) => first.label > second.label ? 1 : -1);
    setThesaurusValues(valuesCopy);
  };

  const addItemSubmit = (items) => {
    const addingNewItems = !items[0]._id;
    const thesaurusValuesCopy = [...thesaurusValues];
    if (addingNewItems) {
      items.forEach((item) => {
        const itemWithId = _objectSpread(_objectSpread({}, item), {}, { _id: `temp_${uniqueID()}` });
        if (!itemWithId.groupId) {
          thesaurusValuesCopy.push(itemWithId);
          return;
        }

        const group = thesaurusValuesCopy.find((groupItem) => groupItem._id === itemWithId.groupId);
        if (group) {
          group.values = group.values || [];
          group.values.push(itemWithId);
        }
      });

      setThesaurusValues(thesaurusValuesCopy);
      return;
    }

    items.forEach((item) => {
      if (!item.groupId) {
        const index = thesaurusValuesCopy.findIndex((tv) => tv._id === item._id);
        thesaurusValuesCopy[index] = item;
        return;
      }

      const group = thesaurusValuesCopy.find((groupItem) => groupItem._id === item.groupId);
      if (group) {var _group$values;
        const index = (_group$values = group.values) === null || _group$values === void 0 ? void 0 : _group$values.findIndex((tv) => tv._id === item._id);
        if (index !== undefined && index !== -1) {
          group.values = group.values || [];
          group.values[index] = item;
        }
      }
    });
    setThesaurusValues(thesaurusValuesCopy);
  };

  const addGroupSubmit = (group) => {
    const thesaurusValuesCopy = thesaurusValues.filter((item) => item._id !== group._id);
    setThesaurusValues([...thesaurusValuesCopy, group]);
  };

  const formSubmit = async (data) => {
    const sanitizedThesaurus = sanitizeThesaurusValues(data, thesaurusValues);
    try {
      const savedThesaurus = await ThesauriAPI.save(sanitizedThesaurus);
      setNotifications({
        type: 'success',
        text: thesaurus ? /*#__PURE__*/
        _jsx(Translate, {}, void 0, "Thesauri updated.") : /*#__PURE__*/

        _jsx(Translate, {}, void 0, "Thesauri added.")

      });
      navigate(`/settings/thesauri/edit/${savedThesaurus._id}`);
    } catch (e) {
      setNotifications({
        type: 'error',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Error updating thesauri.")
      });
    }
  };

  return /*#__PURE__*/(
    _jsx("div", {
      className: "tw-content",
      style: { width: '100%', overflowY: 'auto' },
      "data-testid": "settings-thesauri" }, void 0, /*#__PURE__*/

    _jsx(SettingsContent, { className: "flex flex-col h-full" }, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, {
      path: new Map([['Thesauri', '/settings/thesauri']]),
      title: watch('name') }
    ), /*#__PURE__*/
    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx("form", { onSubmit: handleSubmit(formSubmit), id: "edit-thesaurus" }, void 0, /*#__PURE__*/
    _jsx("div", { "data-testid": "thesauri", className: "border rounded-md shadow-sm border-gray-50" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "p-4" }, void 0, /*#__PURE__*/
    React.createElement(InputField, _extends({
      clearFieldAction: () => {},
      id: "thesauri-name",
      placeholder: "Thesauri name",
      className: "mb-2",
      hasErrors: !!errors.name },
    register('name', { required: true }))
    )
    ), /*#__PURE__*/
    _jsx(Table, {
      draggableRows: true,
      enableSelection: true,
      subRowsKey: "values",
      onChange: setThesaurusValues,
      columns: columns({ edit }),
      data: thesaurusValues,
      initialState: { sorting: [{ id: 'label', desc: false }] },
      onSelection: setSelectedThesaurusValue,
      allowEditGroupsWithDnD: false }
    )
    )
    )
    ), /*#__PURE__*/
    _jsx(SettingsContent.Footer, { className: "bottom-0 bg-indigo-50" }, void 0,
    selectedThesaurusValue.length ? /*#__PURE__*/
    _jsx("div", { className: "flex items-center gap-2" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      type: "button",
      onClick: deleteSelected,
      color: "error",
      "data-testid": "thesauri-remove-button" }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Remove")
    ), /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Selected"), " ", selectedThesaurusValue.length, ' ', /*#__PURE__*/
    _jsx(Translate, {}, void 0, "of"), " ", thesaurusValues.length
    ) : /*#__PURE__*/

    _jsx("div", { className: "flex justify-between w-full" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-2" }, void 0, /*#__PURE__*/
    _jsx(Button, { onClick: addItem }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Add item")
    ), /*#__PURE__*/
    _jsx(Button, { styling: "outline", onClick: addGroup }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Add group")
    ), /*#__PURE__*/
    _jsx(Button, { styling: "outline", onClick: sortValues }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Sort")
    ), /*#__PURE__*/
    _jsx(ImportButton, {
      thesaurus: _objectSpread(_objectSpread({}, getValues()), {}, { values: thesaurusValues }),
      onSuccess: (savedThesaurus) => {
        setNotifications({
          type: 'success',
          text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Thesauri updated.")
        });
        navigate(`/settings/thesauri/edit/${savedThesaurus._id}`);
      },
      onFailure: () => {
        setNotifications({
          type: 'error',
          text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Error adding thesauri.")
        });
      } }
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "flex gap-2" }, void 0, /*#__PURE__*/
    _jsx(Link, { to: "/settings/thesauri" }, void 0, /*#__PURE__*/
    _jsx(Button, { styling: "light", type: "button" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Cancel")
    )
    ), /*#__PURE__*/
    _jsx(Button, { styling: "solid", color: "success", type: "submit", form: "edit-thesaurus" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Save")
    )
    )
    )

    )
    ), /*#__PURE__*/
    _jsx(ThesauriValueFormSidepanel, {
      showSidepanel: showThesauriValueFormSidepanel,
      submit: addItemSubmit,
      value: itemFormValues,
      closePanel: () => {
        setShowThesauriValueFormSidepanel(false);
      },
      groups: thesaurusValues.filter((value) =>
      Array.isArray(value.values)
      ) }
    ), /*#__PURE__*/
    _jsx(ThesauriGroupFormSidepanel, {
      showSidepanel: showThesauriGroupFormSidepanel,
      submit: addGroupSubmit,
      value: groupFormValues,
      closePanel: () => {
        setShowThesauriGroupFormSidepanel(false);
      } }
    ),
    showNavigationModal && /*#__PURE__*/
    _jsx(ConfirmNavigationModal, { setShowModal: setShowNavigationModal, onConfirm: blocker.proceed })

    ));

};

export { ThesaurusForm, editTheasaurusLoader };